enum EPageLoaderTypes {
  PAGE_LOADER_SHOW = 'PageLoader/SHOW_PAGE_LOADER',
  PAGE_LOADER_HIDE = 'PageLoader/HIDE_PAGE_LOADER',
}

export default EPageLoaderTypes;
